import React from 'react'
import PropTypes from 'prop-types'
import MinRating from './MinRating'
import { times } from 'lodash-es'

class MinRatings extends React.Component {
  handleMinRatingChange = minRating => {
    if (this.props.locked) return
    this.props.onMinRatingChange(minRating)
  }

  renderMinRatings = () => {
    const components = times(4, (rating) => {
      return (
        <MinRating
          rating={rating + 1}
          ratingCounts={this.props.ratingCounts}
          onChange={this.handleMinRatingChange}
          selectedRating={this.props.minRating}
          key={`rating-${rating + 1}`}
        />
      )
    })

    components.push(
      <MinRating
        rating={0}
        ratingCounts={this.props.ratingCounts}
        onChange={this.handleMinRatingChange}
        selectedRating={this.props.minRating}
        key='rating-0'
      />
    )

    return components.reverse()
  }

  render () {
    return (
      <div className='filter-options'>
        {this.renderMinRatings()}
      </div>
    )
  }
}

MinRatings.propTypes = {
  minRating: PropTypes.number.isRequired,
  ratingCounts: PropTypes.object.isRequired,
  onMinRatingChange: PropTypes.func.isRequired,
  locked: PropTypes.bool.isRequired
}

export default MinRatings
